import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* getCoreConfig() {
  yield takeEvery(actions.GET_CORE_CONFIGS, function* (action) {
    const { onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/config/core`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_CORE_CONFIGS_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getCoreConfig)]);
}
